import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../app/common/reduxs/async/asyncActions';
import {
  rombelsGet,
  rombelPortalusersGet,
  rombelUpdatePortaluser,
  rombelAdd,
  rombelEdit,
  rombelGet,
  rombelDelete,
} from './reduxAction';
import { ASYNC_ACTION_START } from '../../../../app/common/reduxs/async/asyncConstant';
import { checkErr } from '../../../../app/common/helpers/checkRes';
import { fetchFunc } from '../../../../app/common/helpers/fetchHelpers';
import { toastr } from 'react-redux-toastr';

export const getRombels = ({
  auth,
  history,
  itemPerPage,
  currentPage,
  searchText,
  yearFilter,
  semFilter,
  year,
  sem,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getRombels' });
    const formData = new FormData();
    formData.append('itemPerPage', itemPerPage ? itemPerPage : 10);
    formData.append('currentPage', currentPage);
    formData.append('searchText', searchText);
    if (year) formData.append('year', year);
    if (sem) formData.append('sem', sem);
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'classyear/',
        formData,
        dispatch,
      );
      const items = res.items;
      const total = res.total;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      const search = {
        currentPage,
        searchText,
        itemPerPage: itemPerPage ? itemPerPage : 10,
        yearFilter,
        semFilter,
      };
      dispatch(
        rombelsGet({ total, items, search, jenjangs, kelass, years, sems }),
      );
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getAddOptions = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getAddOptions' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'classyear/add-options/',
        formData,
        dispatch,
      );
      const gurus = res.gurus;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      dispatch(rombelGet({ gurus, jenjangs, kelass, years, sems }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getRombelPortalusers = ({ auth, history, year }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getRombelPortalusers' });
    const formData = new FormData();
    formData.append('year', year);

    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'classyear/portalusers/',
        formData,
        dispatch,
      );
      const portalusers = res?.portalusers;
      const classyears = res?.classyears;
      if (portalusers || classyears)
        dispatch(rombelPortalusersGet({ portalusers, classyears }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const addRombel = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'addRombel' });
    const formData = new FormData();
    formData.append('classyears', JSON.stringify(values.classyears));
    formData.append('jenjang', values.jenjang);
    formData.append('kelas', values.kelas);
    formData.append('year', values.year);
    formData.append('sem', values.sem);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'classyear/add/',
        formData,
        dispatch,
      );

      const rombel = res?.rombel;

      if (rombel?.id) {
        dispatch(rombelAdd(rombel));
      } else {
        history.push('/administrasi/rombel/');
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getRombel = ({ auth, history, id, year, kelasIds, all }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getRombel' });
    const formData = new FormData();
    formData.append('year', year);
    formData.append('kelasIds', kelasIds);
    formData.append('all', all);
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'classyear/detail/' + id,
        formData,
        dispatch,
      );
      const rombel = res.rombel;
      const gurus = res.gurus;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      const portalusers = res.portalusers;
      const classyears = res.classyears;
      dispatch(rombelGet({ rombel, gurus, jenjangs, kelass, years, sems }));
      if (portalusers) {
        dispatch(rombelPortalusersGet({ portalusers, classyears }));
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getUsernamePortalUsers = ({ auth, history, userIds }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getUsernamePortalUsers' });
    const formData = new FormData();
    formData.append('userIds', JSON.stringify(userIds));
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'classyear/get-usernames',
        formData,
        dispatch,
      );
      const portalusers = res.portalusers;
      dispatch(asyncActionFinish());
      return portalusers;
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editRombel = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editRombel' });
    const formData = new FormData();
    formData.append('classyears', JSON.stringify(values.classyears));
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'classyear/edit/' + values.id,
        formData,
        dispatch,
      );
      const rombel = res?.rombel;
      const classyears = rombel.classyears;
      const classyear = classyears?.find((cy) => cy.id + '' === values.id + '');

      if (classyear) {
        dispatch(rombelEdit(classyear));
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editInfoRombel = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editInfoRombel' });
    const formData = new FormData();
    if (values?.students) {
      formData.append('students', JSON.stringify(values.students));
    }
    if (values?.teachers) {
      formData.append('teachers', JSON.stringify(values.teachers));
    }
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'classyear/edit-info/' + values.id,
        formData,
        dispatch,
      );
      const rombel = res?.rombel;

      if (rombel) dispatch(rombelEdit(rombel));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const statusAlumni = ({ auth, history, studentUserId, status }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'statusAlumni' });
    const formData = new FormData();
    formData.append('studentUserId', studentUserId);
    formData.append('status', status);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'classyear/status-alumni/' + studentUserId,
        formData,
        dispatch,
      );
      if (res?.status === 'success') {
        dispatch(rombelUpdatePortaluser({ studentUserId }));
        toastr.success(
          'Berhasil',
          'Set status' + (status ? ' alumni' : ' siswa') + ' berhasil!',
        );
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const statusAllAlumni = ({ auth, history, studentsUserIds, status }) => {
  return async (dispatch, getState) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'statusAllAlumni' });
    const formData = new FormData();
    formData.append('studentsUserIds', JSON.stringify(studentsUserIds));
    formData.append('status', status);
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'classyear/status-all-alumni',
        formData,
        dispatch,
      );
      if (res?.status === 'success') {
        const classyears = getState().rombels.classyears || [];
        dispatch(
          rombelPortalusersGet({ portalusers: [], classyears }),
        );
        toastr.success('Berhasil', 'Set status alumni berhasil!');
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deleteRombel = ({ auth, history, id }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteRombel' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'classyear/delete/' + id,
        formData,
        dispatch,
      );
      const rombel = res.rombel;
      dispatch(rombelDelete(rombel));
      history.push('/administrasi/rombel');
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
